module.exports = __webpack_public_path__ + "img/image02_sp.bd4f6df2.jpg";